import { Link } from 'react-router-dom';
import { siteConfig, navLinks } from '@/mocks/navigation';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/50">
      <div className="mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2.5 mb-4 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-moon-clear-fill text-background-950 text-lg"></i>
              </div>
              <div>
                <span className="text-foreground-950 font-heading font-bold text-lg tracking-wide">
                  {siteConfig.name}
                </span>
              </div>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed max-w-sm">
              {siteConfig.description}
            </p>
          </div>

          <div>
            <h4 className="text-foreground-800 font-medium text-sm mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {navLinks.slice(1, 4).map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-foreground-400 hover:text-foreground-700 text-sm transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-800 font-medium text-sm mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/about"
                  className="text-foreground-400 hover:text-foreground-700 text-sm transition-colors duration-200 cursor-pointer"
                >
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link
                  to="/articles"
                  className="text-foreground-400 hover:text-foreground-700 text-sm transition-colors duration-200 cursor-pointer"
                >
                  导航指南
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-400 text-xs">
            &copy; {new Date().getFullYear()} {siteConfig.name}. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-400 hover:text-foreground-600 text-sm transition-colors duration-200 cursor-pointer" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-foreground-400 hover:text-foreground-600 text-sm transition-colors duration-200 cursor-pointer" rel="nofollow">
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}